var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPayoutInfo3 = function SvgIconPayoutInfo3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.999,
    d: "M15.995 20.993v-2a4 4 0 0 0-3.999-3.998H5.998A4 4 0 0 0 2 18.994v2M8.997 10.996a3.999 3.999 0 1 0 0-7.997 3.999 3.999 0 0 0 0 7.997M21.993 20.993v-2a4 4 0 0 0-3-3.868M15.995 3.129a3.999 3.999 0 0 1 0 7.747"
  })));
};
export default SvgIconPayoutInfo3;